import helper from './helper'

const getEventChainUrlWithParameters = helper.getEventChainUrlWithParameters

export default {
  getEventChainUrlWithParameters,
  /**
   * Базовая функция для построения URL
   */
  getByRecievedUrlData: (url, gets = null) => getEventChainUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  EVENT_CHAIN: {
    SALT:
      /**
       * Получает соль для JWT токена
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения соли
       */
      (gets = null) => getEventChainUrlWithParameters(
        'base|events|get|salt',
        'get',
        null,
        gets
      ),
    JWT:
      /**
       * Получает JWT токен
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения JWT токена
       */
      (gets = null) => getEventChainUrlWithParameters(
        'base|events|get|jwt',
        'get',
        null,
        gets
      )
  }
}
